import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {lighten} from "polished"

import id from "@irati/utils/id"
import {greys, perkbox} from "@irati/ui/src/global/colors"

export const MAX_SCORE = 5

const Wrapper = styled.div`
  position: relative;
  bottom: 0px;
  width: 100%;
  height: 8px;
  background-color: ${greys.light};
  pointer-events: none;
  user-select: none;
  border-radius: 5px;
  display: flex;
  ${({forMobile}) => (forMobile ? "width: calc(100% - 30px);" : "")}
`

const Seek = styled.div`
  position: relative;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 5px;
  background: linear-gradient(to right, ${lighten(0.3, perkbox.blue)}, ${perkbox.blue});
  transition: width 0.25s ease;
  width: ${(props) => `${props.width}%`}
`


const Bar = ({score, ...props}) => {
  const idNamespace = id("Bar", props)
  const width = (score / MAX_SCORE) * 100

  return (
    <Wrapper id={idNamespace} {...props}>
      <Seek id={id("seek", idNamespace)} width={width} />
    </Wrapper>
  )
}


Bar.propTypes = {
  score: PropTypes.number
}
Bar.defaultProps = {
  score: 0
}

export default Bar
